import $ from 'jquery';
import lodashGet from 'lodash/get';

let url = $('meta[name=base-url]').attr('content');
let c = {};

export function setConfig(config, baseUrl = url) {
  c = config;
  url = baseUrl;
}

/**
 * @param {String} key
 * @return {*}
 */
export function get(key) {
  return lodashGet(c, key, null);
}

/**
 * Method returns config value casted to int
 * @param {String} key
 * @return {int}
 */
export function getInt(key) {
  return parseInt(lodashGet(c, key, null), 10);
}

/**
 * @return {*}
 */
export function getBaseUrl() {
  return url;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/core/config.js
 **/